/** @file checkAngleCount: DRAWN_ANGLES_LENGTH unless a drawn-angle array has one value per drawn tile. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

/** Throws `DRAWN_ANGLES_LENGTH` at `path` (hint: the tile count) when `angles` is given with another length. */
export function checkAngleCount(angles: readonly number[] | undefined, tiles: number, path: string): void {
  if (angles === undefined || angles.length === tiles) return;
  throwError(ERROR_CODES.DRAWN_ANGLES_LENGTH, { expected: tiles, got: angles.length }, { path, hint: `give ${tiles} angles, one per drawn tile` });
}
